import { type VideoDmaxInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Box, Center } from "@chakra-ui/react";

export const VideoSection = ({ data }: { data: VideoDmaxInfoResponse }) => {
    const { isMobile } = MEDIA();
    const { video_url, video_apply, video_loc } = data;
    return (
        <Center display={video_apply ? "Flex" : "none"} flexDir="column">
            <Box
                maxW={video_loc === "top" ? "none" : "1600px"}
                w="100%"
                // eslint-disable-next-line no-nested-ternary
                p={video_loc === "base" ? (isMobile ? "16px 16px" : "64px 48px") : "0"}
            >
                <Box
                    as="video"
                    // eslint-disable-next-line no-nested-ternary
                    w="100%"
                    h="auto"
                    // // eslint-disable-next-line no-nested-ternary
                    // borderTopLeftRadius={video_loc === "base" ? (isMobile ? "32px" : "64px") : "0"}
                    // // eslint-disable-next-line no-nested-ternary
                    // borderBottomRightRadius={video_loc === "base" ? (isMobile ? "32px" : "64px") : "0"}
                    src={video_url ?? ""}
                    autoPlay
                    loop
                    muted
                    playsInline
                />
            </Box>
        </Center>
    );
};
